export default {
  methods: {
    num (num) {
      return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    }
  }
}
